var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCircle4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 22,
    viewBox: "0 0 21 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.8472 7.80862L15.1118 9.67526L14.0053 4.32667L9.03009 6.58019L7.16345 0.844727L2.13397 10.7275L15.8177 17.6914L20.8472 7.80862ZM1.33309 16.0625L11.976 21.4788C12.3793 21.6841 12.8475 21.7207 13.2778 21.5807C13.708 21.4406 14.065 21.1354 14.2702 20.7322L15.044 19.2118L1.36021 12.2479L0.586439 13.7683C0.381224 14.1715 0.3446 14.6398 0.484625 15.07C0.624649 15.5003 0.929852 15.8573 1.33309 16.0625Z",
    fill: "#E8D211"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircle4);
export default __webpack_public_path__ + "static/media/circle4.ca06ac9c8f7897cc956671032f86e935.svg";
export { ForwardRef as ReactComponent };